var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel2BorderElec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 200,
    viewBox: "0 0 100 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75baff",
    fillRule: "evenodd",
    d: "M0 0h100v200H0zM2 2h96v196H2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel2BorderElec);
export default __webpack_public_path__ + "static/media/place_model-2_border_elec.d525b7c3452f60680e9370dcec8ce0b5.svg";
export { ForwardRef as ReactComponent };